<template>
    <v-card>
        <v-container>
            <h3>Перед оформлением полиса необходимо подтверждение</h3>
            <v-form v-model="valid" ref="confirm">
                <v-layout xs12 class="small-button-block" v-if="needPhoneConfirm">
                    <v-flex xs7>
                        <v-text-field
                            v-model="validatePhoneCode"
                            :rules="[rules.phoneCode]"
                            mask="#####"
                            label="Код для подтверждение условий ипотечного страхования"
                            validate-on-blur
                            required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs5 class="small-button-block">
                        <v-btn
                            @click="sendPhoneCode"
                            :disabled="false"
                            class="small-button block v-btn"
                        >
                            Отправить Код
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-flex xs12 v-if="healthDeclarationFile">
                    <v-checkbox
                        v-model="checkHealthDeclaration"
                        :rules="[rules.approve]"
                        v-bind:disabled="lockCheckHealthDeclaration"
                        style="pointer-events: all !important;"
                    >
                        <template v-slot:label>
                            <div class="policy-wrapper" style="color: #000 !important;">
                                При оформлении полиса я подтверждаю
                                <a class="policy" target="_blank" :href="healthDeclarationFile">Декларацию о состоянии
                                    здоровья {{ data.lifeName }}</a>
                            </div>
                        </template>
                    </v-checkbox>
                </v-flex>
                <v-flex xs12 v-if="apartmentDeclarationFile">
                    <v-checkbox
                        v-model="checkApartmentDeclaration"
                        :rules="[rules.approve]"
                        validate-on-blur
                    >
                        <template v-slot:label>
                            <div class="policy-wrapper" style="color: #000 !important;">
                                При оформлении полиса я подтверждаю
                                <a class="policy" target="_blank" :href="apartmentDeclarationFile"> Декларацию о
                                    характеристиках недвижимости СК {{ data.apartmentName }}
                                </a>
                            </div>
                        </template>
                    </v-checkbox>
                </v-flex>
                <v-flex xs12 v-if="lifeInsuranceTerms">
                    <v-checkbox
                        v-model="checkLifeInsuranceTerms"
                        :rules="[rules.approve]"
                        validate-on-blur
                    >
                        <template v-slot:label>
                            <div class="policy-wrapper">
                                При оформлении полиса я принимаю
                                <a class="policy" target="_blank" :href="lifeInsuranceTerms"> Правила страхования жизни
                                    СК {{ data.lifeName }}</a>
                            </div>
                        </template>
                    </v-checkbox>
                </v-flex>
                <v-flex xs12 v-if="apartmentInsuranceTerms">
                    <v-checkbox
                        v-model="checkApartmentInsuranceTerms"
                        :rules="[rules.approve]"
                        validate-on-blur
                    >
                        <template v-slot:label>
                            <div class="policy-wrapper">
                                При оформлении полиса я принимаю
                                <a class="policy" target="_blank" :href="apartmentInsuranceTerms"> Правила страхования
                                    недвижимости СК {{ data.lifeName }}</a>
                            </div>
                        </template>
                    </v-checkbox>
                </v-flex>
                <v-flex xs12 v-if="apartmentKidFile">
                    <v-checkbox
                        v-model="checkApartmentKidFile"
                        :rules="[rules.approve]"
                        validate-on-blur
                    >
                        <template v-slot:label>
                            <div class="policy-wrapper">
                                Подтверждаю, что страхователь ознакомлен с информацией о договоре добровольного страхования имущества в виде
                                <a class="policy" target="_blank" :href="apartmentKidFile"> ключевого информационного документа</a>
                            </div>
                        </template>
                    </v-checkbox>
                </v-flex>
                <v-flex xs12 v-if="lifeKidFile">
                    <v-checkbox
                        v-model="checkLifeKidFile"
                        :rules="[rules.approve]"
                        validate-on-blur
                    >
                        <template v-slot:label>
                            <div class="policy-wrapper">
                                Подтверждаю, что страхователь ознакомлен с информацией о договоре добровольного страхования жизни в виде
                                <a class="policy" target="_blank" :href="lifeKidFile"> ключевого информационного документа</a>
                            </div>
                        </template>
                    </v-checkbox>
                </v-flex>
                <!--                <v-flex xs12 v-if="consentProcessingPersonalData">
                                    <v-checkbox
                                        v-model="checkConsentProcessingPersonalData"
                                        :rules="[rules.approve]"
                                        validate-on-blur
                                    >
                                        <template v-slot:label>
                                            <div class="policy-wrapper">
                                                При оформлении полиса я выражаю свое согласие на передачу, обработку и хранение своих
                                                персональных данных.
                                            </div>
                                        </template>
                                    </v-checkbox>
                                </v-flex>-->
                <v-flex xs12 v-if="sovcomProcessingPersonalData">
                    <v-checkbox
                        v-model="checkSovcomProcessingPersonalData"
                        :rules="[rules.approve]"
                        validate-on-blur
                    >
                        <template v-slot:label>
                            <div class="policy-wrapper">
                                Я даю согласие «Совкомбанк страхование» (АО) на обработку моих персональных данных
                                <a class="policy" target="_blank" href="https://sovcomins.ru/upload/personal/soglasie_na_obrabotky_pd.pdf"> для целей оказания услуг страхования</a>
                            </div>
                        </template>
                    </v-checkbox>
                </v-flex>
                <v-flex xs12 v-if="sovcomProcessingPersonalData">
                    <v-checkbox
                        v-model="checkSovcomProcessingAgreement"
                        :rules="[rules.approve]"
                        validate-on-blur
                    >
                        <template v-slot:label>
                            <div class="policy-wrapper">
                                При оформлении полиса я подтверждаю, что:
                                <ul>
                                    <li>проинформирован, что в случае предоставления мной ложных сведений или сокрытия информации, договор страхования может быть признан недействительным в соответствии с действующим законодательством РФ;</li>
                                    <li>получил ключевой информационный документ, с условиями страхования ознакомлен и согласен;</li>
                                    <li>оплачивая страховую премию (страховой взнос), я выражаю свое согласие на заключение договора страхования.</li>
                                </ul>
                            </div>
                        </template>
                    </v-checkbox>
                </v-flex>
                <v-flex xs12 v-for="term in customLifeInsuranceTerms" v-bind:key="term.text">
                    <v-checkbox
                        v-model="checkCustomLifeInsuranceTerms"
                        :rules="[rules.approve]"
                        validate-on-blur
                    >
                        <template v-slot:label>
                            <div class="policy-wrapper">
                                {{ term.text }}<a class="policy" target="_blank" :href="term.link"> Условия</a>
                            </div>
                        </template>
                    </v-checkbox>
                </v-flex>
                <v-flex xs12 v-for="term in customApartmentInsuranceTerms" v-bind:key="term.text">
                    <v-checkbox
                        v-model="checkCustomApartmentInsuranceTerms"
                        :rules="[rules.approve]"
                        validate-on-blur
                    >
                        <template v-slot:label>
                            <div class="policy-wrapper">
                                {{ term.text }}<a class="policy" target="_blank" :href="term.link"> Условия</a>
                            </div>
                        </template>
                    </v-checkbox>
                </v-flex>
                <v-flex xs12 sm12 v-if="apartmentPolicyStartDate || lifePolicyStartDate" style="padding-bottom: 10px">
                    <div class="policy-wrapper" v-if="apartmentPolicyStartDate">
                        {{ apartmentPolicyStartDate }}
                    </div>
                    <div class="policy-wrapper" v-if="lifePolicyStartDate">
                        {{ lifePolicyStartDate }}
                    </div>
                </v-flex>
                <v-flex xs12 sm3 lg3 class="mortgage-list__button-block">
                    <v-btn @click="validate"
                           :disabled="false"
                           :loading="wait"
                           class="button submit-button block">Оформить
                    </v-btn>
                </v-flex>
            </v-form>
        </v-container>
    </v-card>
</template>

<script>
export default {
    name: "MortgageConfirmModal",
    props: {
        dialog: Boolean,
        data: {
            apartment: String,
            apartmentImage: String,
            apartmentName: String,
            apartmentRequirements: this.requirements,
            apartmentStartPolicyDate: String,
            life: String,
            lifeImage: String,
            lifeName: String,
            lifeRequirements: this.requirements,
            lifeStartPolicyDate: String,
            commission: Number,
            error: String,
        },
        phone: String,
        wait: Boolean,
        isLink: Boolean,
        dialogConfirmModal: Boolean,
    },
    data: () => ({
        valid: false,
        validatePhoneCode: '',
        healthDeclarationFile: null,
        checkHealthDeclaration: false,
        apartmentDeclarationFile: null,
        checkApartmentDeclaration: false,
        consentProcessingPersonalData: null,
        checkConsentProcessingPersonalData: false,
        sovcomProcessingPersonalData: null,
        checkSovcomProcessingPersonalData: false,
        checkSovcomProcessingAgreement: false,
        lifeInsuranceTerms: null,
        checkLifeInsuranceTerms: false,
        apartmentInsuranceTerms: null,
        apartmentKidFile: null,
        lifeKidFile: null,
        checkApartmentKidFile: false,
        checkLifeKidFile: false,
        checkApartmentInsuranceTerms: false,
        complexInsuranceTerms: null,
        checkComplexInsuranceTerms: false,
        insuranceTerms: null,
        checkInsuranceTerms: false,
        customLifeInsuranceTerms: [],
        checkCustomLifeInsuranceTerms: false,
        customApartmentInsuranceTerms: [],
        checkCustomApartmentInsuranceTerms: false,
        lockCheckHealthDeclaration: false,
        needPhoneConfirm: false,
        needHealthDeclaration: false,

        apartmentPolicyStartDate: null,
        lifePolicyStartDate: null,

        apartmentStartPolicyDate: null,
        lifeStartPolicyDate: null,

        requirements: {
            mortgage_company_id: null,
            mortgage_bank_id: null,
            need_phone_confirm: null,
            need_health_declaration: null,
            health_declaration_file: null,
            apartment_declaration_file: null,
            life_insurance_terms: null,
            apartment_insurance_terms: null,
            apartment_kid: null,
            life_kid: null,
            life_insurance_example: null,
            apartment_insurance_example: null,
            complex_insurance_example: null,
            insurance_rules: null,
            custom_insurance_rules: null,
        },

        rules: {
            required: v => !!v || 'Обязательное поле',
            phoneCode: v => /^\d{5}$/.test(v) || 'Неверный формат',
            approve: v => v || 'Для оформления полиса необходимо согласиться с условиями',
        },
    }),
    methods: {
        sendPhoneCode() {
            axios.post('/create-pin/registration', {
                phone: this.phone,
            }).then(() => {
                PNotify.success('Код отправлен');
            }).catch(error => {
                console.log(error.response);
                PNotify.error(error.response.data.message);
            })
        },
        validate() {
            if (this.$refs.confirm.validate()) {
                this.checkCode();
            } else {
                this.$nextTick(function () {
                    PNotify.error('Проверьте правильность выделенных полей.')
                    this.goToFirstError(true)
                });
            }
        },
        checkCode() {
            this.$emit('isSubmitLoading', true);
            axios.post('/create-pin/verify', {
                phone: this.phone,
                code: this.validatePhoneCode,
            }).then(() => {
                this.data.isLink = this.isLink;
                this.$emit('issue', this.data)
            }).catch(error => {
                this.$emit('isSubmitLoading', false);
                console.log(error.response);
                PNotify.error(error.response.data.message);
            })
        },
        unlock() {
            this.lockCheckHealthDeclaration = false;
        },
        updateRequirements() {
            if (this.data.lifeRequirements != null) {
                if (this.data.lifeRequirements.need_phone_confirm) {
                    this.needPhoneConfirm = this.data.lifeRequirements.need_phone_confirm
                }
                if (this.data.lifeRequirements.need_health_declaration) {
                    this.needHealthDeclaration = this.data.lifeRequirements.need_health_declaration
                }
                this.healthDeclarationFile = this.data.lifeRequirements.health_declaration_file
                this.lifeInsuranceTerms = this.data.lifeRequirements.life_insurance_terms;
                this.lifeKidFile = this.data.lifeRequirements.life_kid;
                if (this.data.lifeRequirements.custom_insurance_rules) {
                    JSON.parse(this.data.lifeRequirements.custom_insurance_rules).forEach(term => {
                        if (term.type === "life") this.customLifeInsuranceTerms.push(term)
                    })
                }
            }
            if (this.data.apartmentRequirements != null) {
                if (this.data.apartmentRequirements.need_phone_confirm) {
                    this.needPhoneConfirm = this.data.apartmentRequirements.need_phone_confirm
                }
                this.apartmentDeclarationFile = this.data.apartmentRequirements.apartment_declaration_file
                this.apartmentInsuranceTerms = this.data.apartmentRequirements.apartment_insurance_terms
                this.apartmentKidFile = this.data.apartmentRequirements.apartment_kid
                if (this.data.apartmentRequirements.custom_insurance_rules) {
                    JSON.parse(this.data.apartmentRequirements.custom_insurance_rules).forEach(term => {
                        if (term.type === "apartment") this.customApartmentInsuranceTerms.push(term)
                    })
                }
            }
            if (this.data.apartmentName === "Абсолют" || this.data.lifeName === "Абсолют") {
                this.consentProcessingPersonalData = true;
                if (this.data.apartmentRequirements) {
                    this.complexInsuranceTerms = this.data.apartmentRequirements.insurance_rules;
                } else if (this.data.lifeRequirements) {
                    this.complexInsuranceTerms = this.data.lifeRequirements.insurance_rules;
                }
            }

            if (this.data.apartmentName === "Совкомбанк" || this.data.lifeName === "Совкомбанк") {
                this.sovcomProcessingPersonalData = true;
            }

            if (!this.needHealthDeclaration) {
                if (this.data.apartmentName === this.data.lifeName) {
                    if (this.data.apartmentStartPolicyDate != null || this.data.lifeRequirements != null) {
                        this.insuranceTerms = this.data.apartmentRequirements.insurance_rules || this.data.lifeRequirements.insurance_rules || null;
                    }
                }
                this.healthDeclarationFile = false;
            }
            if (this.data.apartmentStartPolicyDate != null) {
                let date = new Date(Date.parse(this.data.apartmentStartPolicyDate))
                this.apartmentPolicyStartDate = `Внимание! Полис страхования недвижимости начинается с ${date.toLocaleDateString('ru')}`
            }

            if (this.data.lifeStartPolicyDate != null) {
                let date = new Date(Date.parse(this.data.lifeStartPolicyDate))
                this.lifePolicyStartDate = `Внимание! Полис страхования жизни начинается с ${date.toLocaleDateString('ru')}`
            }
        }
    },
    watch: {
        dialogConfirmModal: {
            handler() {
                if (this.dialogConfirmModal) {
                    this.updateRequirements();
                } else {
                    this.needPhoneConfirm = null;
                    this.healthDeclarationFile = null;
                    this.apartmentDeclarationFile = null;
                    this.lifeInsuranceTerms = null;
                    this.apartmentInsuranceTerms = null;
                    this.apartmentKidFile = null;
                    this.lifeKidFile = null;
                    this.customLifeInsuranceTerms = null;
                    this.customApartmentInsuranceTerms = null;
                    this.apartmentPolicyStartDate = null;
                    this.lifePolicyStartDate = null;
                }
            }
        },
    }
}
</script>

<style scoped>
.small-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    text-transform: none !important;
    box-shadow: none !important;
    height: 40px;
    background-color: #00ba57 !important;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
    padding: 0 20px;
    margin: 0 0 0 20px;
}

.small-button-block {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
}

.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important;
    height: 56px;
    width: 100%;
    background-color: #00ba57 !important;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;
    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/mortgage/MortgageConfirmModal.vue